<ul *ngIf="items" class="ul ul--lg ul--circle ul--two-col">
  <li [ngClass]="anchorClass" *ngFor="let item of items">{{ item }}</li>
</ul>
